import { render, staticRenderFns } from "./ProspectFastForm.vue?vue&type=template&id=63e4626a"
import script from "./ProspectFastForm.vue?vue&type=script&lang=ts"
export * from "./ProspectFastForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports